/* ============================================================
   HYPE SIDE — Carrinho lateral (snippets/cart-drawer.liquid)

   - Dia de envio no rodapé
   - Progresso do "Leva 3, paga 2": a barra cresce a partir do valor
     anterior e a camisola nova "salta" para o lugar; ao completar 3, festa

   O tema substitui o HTML do painel a cada alteração, por isso tudo
   corre outra vez quando o conteúdo muda (MutationObserver).
   ============================================================ */
(function () {
  var CHAVE = 'hcd_progresso';

  function lerAnterior() {
    try { return JSON.parse(sessionStorage.getItem(CHAVE) || 'null'); } catch (e) { return null; }
  }
  function gravar(v) {
    try { sessionStorage.setItem(CHAVE, JSON.stringify(v)); } catch (e) {}
  }

  // Dia de envio: amanhã, e ao domingo não se envia (igual à página de produto)
  function entrega(drawer) {
    var alvo = drawer.querySelector('[data-hcd-eta-text]');
    if (!alvo) return;
    var dias = ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sáb'];
    var meses = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];
    var d = new Date();
    d.setDate(d.getDate() + 1);
    var amanha = d.getDay() !== 0;
    if (!amanha) d.setDate(d.getDate() + 1);
    var dia = dias[d.getDay()] + ' ' + d.getDate() + ' ' + meses[d.getMonth()];
    var texto = amanha ? 'Será enviada amanhã, ' + dia : 'Será enviada ' + dia;
    if (alvo.textContent !== texto) alvo.textContent = texto;
    var linha = alvo.closest('[data-hcd-eta]');
    if (linha && linha.hidden) linha.hidden = false;
  }

  function promo(drawer) {
    var caixa = drawer.querySelector('[data-hcd-promo]');
    if (!caixa) {
      if (!drawer.querySelector('.cart-item')) gravar(null);
      return;
    }
    if (caixa.hasAttribute('data-hcd-pronto')) return;
    caixa.setAttribute('data-hcd-pronto', '');

    var pecas = parseInt(caixa.getAttribute('data-pecas'), 10) || 0;
    var completo = caixa.getAttribute('data-completo') === 'true';
    var fill = caixa.querySelector('[data-hcd-fill]');
    var alvo = fill ? fill.style.width : '0%';
    var antes = lerAnterior();
    gravar({ pecas: pecas, largura: alvo });

    var reduz = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduz || !fill) return;

    // A barra parte de onde estava (ou do zero na primeira vez) e cresce até ao valor novo
    var inicio = antes && antes.pecas < pecas && !completo ? antes.largura : '0%';
    if (antes && antes.pecas > pecas) inicio = alvo;
    fill.style.transition = 'none';
    fill.style.width = inicio;
    void fill.offsetWidth;
    fill.style.transition = '';
    requestAnimationFrame(function () { fill.style.width = alvo; });

    if (antes && pecas > antes.pecas) {
      var ultimo = completo ? 2 : ((pecas - 1) % 3);
      var passo = caixa.querySelector('[data-hcd-step="' + ultimo + '"]');
      if (passo) passo.classList.add('is-new');
      if (completo) caixa.classList.add('is-celebrate');
    }
  }

  function preparar() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;
    // O renderContents do tema não tira o "is-empty" do sítio certo: sem isto, quem junta
    // a primeira camisola por outro caminho que não o formulário do produto via o painel vazio
    var temArtigos = !!drawer.querySelector('.cart-item');
    if (temArtigos === drawer.classList.contains('is-empty')) drawer.classList.toggle('is-empty', !temArtigos);
    entrega(drawer);
    promo(drawer);
  }

  var agendado = false;
  function agendar() {
    if (agendado) return;
    agendado = true;
    setTimeout(function () { agendado = false; preparar(); }, 0);
  }

  document.addEventListener('DOMContentLoaded', function () {
    preparar();
    var drawer = document.querySelector('cart-drawer');
    if (drawer) new MutationObserver(agendar).observe(drawer, { childList: true, subtree: true });
  });
})();
